import { ProjectId } from 'api/models';
import { useProjectDetailWebsocket } from './use-project-detail-websocket';
import { useProjectMembersWebsocket } from './use-project-members-websocket';
import { useProjectPhaseWebsocket } from './use-project-phase-websocket';
import { useProjectPlaceholderWebsocket } from './use-project-placeholder-websocket';
import { useProjectSpaceWebsocket } from './use-project-space-websocket';
import { useProjectTaskWebsocket } from './use-project-task-websocket';

export const useProjectWebsocket = (projectId: ProjectId): void => {
  useProjectDetailWebsocket(projectId);
  useProjectMembersWebsocket(projectId);
  useProjectPhaseWebsocket(projectId);
  useProjectSpaceWebsocket(projectId);
  useProjectTaskWebsocket(projectId);
  useProjectPlaceholderWebsocket(projectId);
};
